import { SectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCoreAsset, PolicyChangeType, Quote } from '../../../../domain'
import { useErrorHandlingAsyncCallback } from '../../../../hooks/errors'
import { usePrincipal } from '../../../authentication'
import { AddOnSection } from '../../../organisms/product/AddOnSection'
import { useProposal } from '../../proposal/ProposalProvider'

export interface RenewalAddOnSectionProps extends SectionProps {
  quote: Quote
}

export const RenewalAddOnSection: FunctionComponent<RenewalAddOnSectionProps> = ({
  quote,
  ...props
}) => {
  const { apiClient } = usePrincipal()
  const { assetCode } = getCoreAsset(quote)
  const {
    proposal: { proposalCode },
    setProposal,
  } = useProposal()

  const { loading, execute } = useErrorHandlingAsyncCallback(
    async (
      coverCode: string,
      changeType: PolicyChangeType.ADD_COVER | PolicyChangeType.REMOVE_COVER,
    ) =>
      setProposal(
        await apiClient.updateProposal(proposalCode, {
          changes: [{ assetCode, changeType, coverCode }],
        }),
      ),
  )

  return <AddOnSection loading={loading} quote={quote} onChange={execute} {...props} />
}
